"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VChip;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _Icon = _interopRequireDefault(require("../../Graphics/Icon/Icon"));

var _Colors = _interopRequireDefault(require("../../Basic/Colors/Colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyles = (0, _core.makeStyles)({
  root: {
    color: _Colors.default.sinineVaal,
    backgroundColor: _Colors.default.withOpacity(_Colors.default.sinineVaal, 0.1),
    borderRadius: 5,
    height: 24,
    fontSize: 12
  }
});

function VChip(_ref) {
  var rest = _extends({}, _ref);

  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Chip, _extends({
    classes: {
      root: classes.root
    }
  }, rest, {
    deleteIcon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: "times",
      size: "16px",
      color: _Colors.default.sinineVaal
    })
  }));
}